import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'otherActivityReport';

const otherActivityReportService = {
  getData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  checkOpenReportByUser: (userId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/checkOpenReport/${encodeURIComponent(userId)}`,
    });
  },

  startJob: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/startJob`,
      data,
    });
  },

  stopJob: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/stopJob`,
      data,
    });
  },
};
export default otherActivityReportService;
